// extracted by mini-css-extract-plugin
export default {"imgdiv":"a063c8bf41 _0955e01f14","img":"_036c4171e5 _3bd87ff5b9"};